import { Component, NgZone, OnInit } from '@angular/core';
import { NavController, LoadingController, ModalController } from '@ionic/angular';
import { UserService, } from '../user.service';
import { RestService } from '../rest.service';
import { Req, loadOpt, Register} from '../../environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { FCM } from 'plugins/cordova-plugin-fcm-with-dependecy-updated/ionic/ngx/FCM';
import * as CryptoJS from 'crypto-js';
import { Globals } from '../globals';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { Device } from '@ionic-native/device/ngx';
import { MapComponent } from '../map/map.component';


declare var google;

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  public register: Register;
  public rgpd: boolean = false;
  public direccionValida: boolean = true;
  public numeroDisabled: boolean = false;
  public postalCodeDisabled: boolean = false;

  autocomplete: { 
    input: string; 
  };

  autocompleteItems: any[];
  GoogleAutocomplete: any;
  placesService: any;
  lat: string = '';
  lng: string = '';

  constructor(
    private nav: NavController,
    private rest: RestService,
    private iab: InAppBrowser,
    public stop: LoadingController,
    public user: UserService,
    private fcm: FCM,
    public global: Globals,
    private zone: NgZone,
    private modalCtrl: ModalController,
    private storage: NativeStorage,
    private device: Device,
    ) { 
      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
      this.autocompleteItems = [];
      this.autocomplete = { input: '' };
    }

  ngOnInit() {
    this.global.disabled = false;

    this.register = {
      email : '',
      name: '',
      last_name: '',
      pass_repeat : '',
      pass: '',
      phone: '',
      address: '',
      number: '',
      door: '',
      postal_code: '',
    };
  }

  gotoLogin() { this.nav.navigateRoot('login'); }

  async postRegister() {

    if (!this.rgpd){
      this.user.generateToast('Acepta la RGPD primero');
      return 0;
    }

    

    const loading = await this.stop.create(loadOpt);
    await loading.present(); 

    if (this.ValidateEmail(this.register.email)) {

      this.register.address = this.autocomplete.input;

      this.rest.Register(this.register, this.global.lat, this.global.lng).subscribe( (data: Req) => {

        this.user.data = data.data['user'];
        this.user.data.token = data.data['token'];
        this.user.isLoggedIn = true;
        this.user.setAuth(data.data);

        // this.fcm.subscribeToTopic('user_' + data.data['user']['id']);
        
        

        
      }, (error) => {
        this.user.generateToast(error['error']['data']);
        loading.dismiss();
      });

    }
    

    if(localStorage.getItem('lastURL').indexOf('commerce') >= 0){
      this.nav.navigateRoot(localStorage.getItem('lastURL'))
    }else{
      this.nav.navigateRoot('tabs');
    }
    // this.nav.navigateRoot('tabs/tab1');

    loading.dismiss();


  }

  ValidateEmail(mail) {

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }

    this.user.generateToast('Introduce un email válido');

    return false;
  }

  viewRgpd(){
    this.iab.create('https://yadeyaencasa.com/info/aviso-legal', '_system');
  }


  UpdateSearchResults(){
    this.cambiaDireccion();
    if (this.autocomplete.input.trim() == '') {
      this.autocompleteItems = [];
      this.global.disabled = false;
      this.numeroDisabled = false;
      this.postalCodeDisabled = false;
      this.register.address = '';
      this.register.number = '';
      this.register.postal_code = '';
      this.register.door = '';
      return;
    }
    const config = {
      types: ['geocode'],
      input: this.autocomplete.input,
      componentRestrictions: {country: 'es'}
    };
    this.numeroDisabled = true;
    this.postalCodeDisabled = true;

    if (this.autocomplete.input == this.global.nombreCalle){
      this.autocompleteItems = [];

    }else{
      this.GoogleAutocomplete.getPlacePredictions(config,
        (predictions, status) => {
           
          this.autocompleteItems = [];
          this.zone.run(() => { 
            predictions.forEach((prediction) => {
              this.autocompleteItems.push(prediction);
            });
          });
        });
    
    }
    if (this.autocomplete.input == '') {
      this.autocompleteItems = [];
      return;
    }
  }

  changeNumber(){
    if (this.register.address.trim() == '') {
      this.numeroDisabled = false;
      return;
    } else if (this.register.address.trim() != '' && this.register.number.trim() == '') {
      this.numeroDisabled = true;
      return;
    }
    this.numeroDisabled = false;
  }

  changeCP(){
    if (this.register.address.trim() == '') {
      this.postalCodeDisabled = false;
      return;
    } else if (this.register.address.trim() != '' && this.register.postal_code.trim() == '') {
      this.postalCodeDisabled = true;
      return;
    }
    this.postalCodeDisabled = false;
  }

  cambiaDireccion(){
    if (this.autocomplete.input.trim() == this.global.nombreCalle) {
      this.global.disabled = false;  
    }else{
      this.global.disabled = true;
    }
    
  }

  ClearAutocomplete(){
    if (this.autocomplete.input == '') {
      this.autocompleteItems = [];
      this.autocomplete.input = '';
      this.register.address = '';  
    }
    
  }

  async SelectSearchResult(place){
    
    this.global.disabled = false;
    const loading = await this.stop.create(loadOpt);
    await loading.present();
    this.global.nombreCalle = place.description;
    this.autocomplete.input = place.description;
    this.autocompleteItems = [];
    this.register.address = place.description; 

    this.placesService.getDetails({placeId: place.place_id}, (details) => {

        details.address_components.forEach(add => {
          if ( add.types[0] === 'postal_code' ){ this.register.postal_code = add.long_name; }
        });
        details.address_components.forEach(add => {
        });
        this.global.lat = details.geometry.location.lat();
        this.global.lng = details.geometry.location.lng();
        loading.dismiss();

    });
    this.autocompleteItems = [];
    setTimeout(() => loading.dismiss(), 4500);
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: MapComponent,
      cssClass: 'my-custom-class',
      componentProps: {
        'firstName': 'Douglas',
        'lastName': 'Adams',
        'middleInitial': 'N'
      }
    });
    this.ClearAutocomplete();
    return await modal.present();
  }

  clearSugerencias(){
    this.autocompleteItems = [];
  }

}
